// https://vuex.vuejs.org/en/state.html


export default {
  version: process.env.VUE_APP_VERSION
}
